import React from 'react';
import { Link, useNavigate } from 'react-router';
import { Button } from '../../components/Button';
import { TAN_BG } from '../../data/constants';
import { useOrderRoute } from '../../contexts/OrderContext';

export function HowItWorks() {
  const navigate = useNavigate();
  const orderRoute = useOrderRoute();
  const [openStep, setOpenStep] = React.useState<number | null>(null);

  const steps = [
    {
      title: 'Choose a bidet you love',
      body: (
        <span>
          Browse our
          {' '}
          <Link to="/bidets" className="underline text-blue-700">Recommended Bidets</Link>
          {' '}
          and pick the one that's right for you.
        </span>
      ),
    },
    {
      title: 'We come over and install it',
      body: (
        <span>
          Schedule your installation on our
          {' '}
          <Link to={orderRoute} className="underline text-blue-700">Order page</Link>
          {' '}
          and we'll handle the rest.
        </span>
      ),
    },
    {
      title: 'Experience cleanliness, comfort, and delight',
      body: (
        <span>
          Enjoy your new bidet and a whole new level of freshness!
        </span>
      ),
    },
  ];
  return (
    <section className="pb-4 pt-8" style={{ backgroundColor: TAN_BG }}>
      {/* Accordion transition styles */}
      <style>
        {`
        .accordion-content {
          opacity: 0;
          height: 0;
          overflow: hidden;
          transition: opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1), height 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .accordion-content.open {
          opacity: 1;
          height: auto;
        }
      `}
      </style>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-stretch md:justify-center items-center justify-center max-w-[1200px] mx-auto">
            <div className="w-full md:w-1/2 flex-shrink-0 flex-grow-0">
            <img
              src="/images/shower.jpg"
              alt="Suitcase with toilet paper"
              className="w-full h-auto md:h-full object-cover object-bottom
              rounded-t-xl md:rounded-tl-xl md:rounded-bl-xl
              md:rounded-tr-none md:rounded-br-none"
              style={{ maxHeight: '500px' }}
            />
            </div>
          <div className="bg-white w-full md:w-1/2 flex flex-col justify-center items-center
            rounded-b-xl md:rounded-b-none md:rounded-tr-xl md:rounded-br-xl
            md:rounded-tl-none md:rounded-bl-none
            shadow-lg p-8 md:flex-1"
          >
            <div className="flex flex-col items-center text-center w-full px-2 mx-auto">
              <h2 className="text-xl font-bold mb-6">How it works</h2>
              <div className="w-full">
                {steps.map((step, idx) => (
                  <div key={idx} className="border-b border-gray-300 last:border-b-0">
                    <button
                      className="flex items-center justify-between w-full py-4 px-2 focus:outline-none"
                      onClick={() => setOpenStep(openStep === idx ? null : idx)}
                      aria-expanded={openStep === idx}
                      aria-controls={`step-body-${idx}`}
                    >
                      <span className="flex items-center">
                        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-yellow-200 mr-3 border border-yellow-400">
                          <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
                            <circle cx="8" cy="8" r="7" stroke="#b59d2b" strokeWidth="1.5" fill="none" />
                            <path d="M5.5 8.5l2 2 3-3" stroke="#b59d2b" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </span>
                        <span className="font-semibold text-left text-base">{step.title}</span>
                      </span>
                      <span className={`transition-transform duration-200 ${openStep === idx ? 'rotate-180' : ''}`}>
                        <svg width="20" height="20" fill="none" viewBox="0 0 20 20"><path d="M6 8l4 4 4-4" stroke="#b59d2b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                      </span>
                    </button>
                    <div
                      id={`step-body-${idx}`}
                      className={`accordion-content px-4 text-sm text-gray-700 text-left bg-[#f7f3ea] rounded-lg mt-0 mb-2${openStep === idx ? ' open' : ''}`}
                      aria-hidden={openStep !== idx}
                    >
                      <div className="py-4">
                        {step.body}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <Button
                type="button"
                cta
                onClick={() => navigate('/pricing')}
                className="mt-8"
              >
                See Pricing
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
